import { Property } from "./interfaces";

export const diasTratamiento: Property = {
    title: "Días de Tratamiento",
    type: "integer"
}